<template>
    <v-flex xs12>
      <v-card>
        <v-flex xs12 px-4 v-if="err">
          <v-alert :value="true" type="error">{{err}}</v-alert>
        </v-flex>
        <v-card-title class="pb-0 px-4 layout row wrap">
          <v-btn class="primary ma-0" @click='$router.push({ name: "createAccount" })'>{{$lang.actions.createAccount}}</v-btn>
           <v-checkbox
            color="primary"
            class="ml-3 mt-0"
            :label="$lang.labels.showActive"
            v-model="showActive"
            hide-details
           />
          <v-spacer />
          <v-text-field
            class="min-w max-w"
            v-model="search"
            append-icon="search"
            :label="$lang.labels.search"
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="showActive ? activeAccounts : allAccounts"
          :search="search"
          :loading="allAccounts.length === 0"
          :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
        >
          <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.userName}}</td>
            <td>{{ props.item.companyName }}</td>
            <td>{{ props.item.accountStatus }}</td>
            <td class="min-w-lg">
              <v-btn class="primary mx-0 elevation-1" @click="$router.push({ name: 'editAccunt', params: { id: props.item.id } })">{{$lang.actions.edit}}</v-btn>
              <v-btn class="primary elevation-1" @click="changeStatus(props.item)">{{props.item.accountStatus === 'active' ? $lang.actions.deactivate : $lang.actions.activate}}</v-btn>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="warning" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
</template>

<script>
  export default {
    data() {
      return {
        showActive: true,
        err: '',
        search: '',
        headers: [
          {text: this.$lang.labels.name, value: 'name', align: 'left',},
          {text: this.$lang.labels.username, value: 'userName', align: 'left',},
          {text: this.$lang.labels.company, value: 'companyName', align: 'left',},
          {text: this.$lang.labels.status, value: 'accountStatus', align: 'left',},
          {text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false,},
        ],
        allAccounts: [],
      };
    },
    methods: {
      changeStatus(account) {
        const action = account.accountStatus === 'active' ? 'deactivate' : 'activate';
        this.$http.post(`account/${action}/${account.id}`)
        .then((res) => {
          if (res.body.status === 'Success') {
            this.$set(account, 'accountStatus', action === 'activate' ? 'active' : 'inactive');
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      }
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    computed: {
      activeAccounts() {
        const accounts = this.allAccounts;
        const activeAccounts = [];
        for (let i=0; accounts.length > i; i++) {
          if (accounts[i].accountStatus === 'active') {
            activeAccounts.push(accounts[i]);
          }
        }
        return activeAccounts;
      },
    },
    created() {
      this.$http.get('account')
        .then((res) => {
          if (res.body.status === 'Success') {
            this.allAccounts = res.body.accounts;
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
    }
  };
</script>



// WEBPACK FOOTER //
// Accounts.vue?643f4267